import React from 'react';
import { Flex } from 'rebass';
import Frame from 'components/Frame';
import useJobPost from 'modules/JobPosts/hooks/useJobPost';
import CreateJobPostForm from 'modules/JobPosts/components/CreateJobPostForm';

const EditJobPost: React.FC<any> = ({ match }): JSX.Element => {
  const { jobPost } = useJobPost(+match.params.id);
  return (
    <>
      <Frame>
        <Flex width="100%" flexDirection="column">
          <CreateJobPostForm initialValues={jobPost} jobPostId={+match.params.id} />
        </Flex>
      </Frame>
    </>
  );
};

export default EditJobPost;
